import messages from "@/messages/en.json";
import type { BeerOnTap } from "@/lib/real-ale-finder/real-ale-finder.types";

const t = messages.whatsOnTap.beerCard;

interface BeerCardBackProps {
  beer: BeerOnTap;
}

/**
 * Dark-variant "back of card" — shown when the user clicks the card and
 * the front face flips over. Pure presentational: no interactivity.
 */
export function BeerCardBack({ beer }: BeerCardBackProps) {
  return (
    <div className="bg-hop rounded-card flex h-full flex-col px-6 py-6 text-white">
      <div className="mb-4 flex items-baseline justify-between gap-2">
        <h3 className="font-display text-base leading-snug font-bold">
          {beer.name}
        </h3>
        {beer.style && (
          <span className="text-mono-sm font-mono opacity-80">{beer.style}</span>
        )}
      </div>

      <div className="mb-5 flex-1">
        {beer.notes ? (
          <p className="text-mono-sm font-mono leading-relaxed opacity-90">
            {beer.notes}
          </p>
        ) : (
          <p className="text-mono-sm font-mono leading-relaxed opacity-70">
            {t.interaction.notesUnavailable}
          </p>
        )}
      </div>

      <dl className="border-t border-white/20 pt-3 text-sm">
        {beer.abv && (
          <div className="flex items-baseline justify-between py-1">
            <dt className="text-mono-sm font-mono font-medium opacity-80">
              {t.label.abv}
            </dt>
            <dd className="text-mono-sm font-mono">{beer.abv}%</dd>
          </div>
        )}
        {beer.container && (
          <div className="flex items-baseline justify-between py-1">
            <dt className="text-mono-sm font-mono font-medium opacity-80">
              {t.label.style}
            </dt>
            <dd className="text-mono-sm font-mono">{beer.container}</dd>
          </div>
        )}
        {(beer.isVegan || beer.isGlutenFree) && (
          <div className="flex items-baseline justify-between py-1">
            <dt className="text-mono-sm font-mono font-medium opacity-80">
              {t.label.notes}
            </dt>
            <dd className="text-mono-sm font-mono">
              {[
                beer.isVegan && t.label.vegan,
                beer.isGlutenFree && t.label.glutenFree,
              ]
                .filter(Boolean)
                .join(", ")}
            </dd>
          </div>
        )}
      </dl>
    </div>
  );
}
